module.exports = __webpack_public_path__ + "img/oliver-b.f1196e19.png";